import { portalCustomerApiSlice } from "./portalCustomerApiSlice";

export const portalCartApiSlice = portalCustomerApiSlice.injectEndpoints({
  endpoints: builder => ({
    getPortalCart: builder.query({
      query: () => "/api/portal/v1/cart/",
      providesTags: ["PortalCart"],
    }),

    addPortalCartItem: builder.mutation({
      query: ({ product_id, quantity }) => ({
        url: "/api/portal/v1/cart_items/",
        method: "POST",
        body: { product_id, quantity },
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(portalCartApiSlice.util.updateQueryData("getPortalCart", undefined, () => data));
        } catch {}
      },
    }),

    updatePortalCartItem: builder.mutation({
      query: ({ id, quantity }) => ({
        url: `/api/portal/v1/cart_items/${id}/`,
        method: "PATCH",
        body: { quantity },
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(portalCartApiSlice.util.updateQueryData("getPortalCart", undefined, () => data));
        } catch {}
      },
    }),

    removePortalCartItem: builder.mutation({
      query: id => ({
        url: `/api/portal/v1/cart_items/${id}/`,
        method: "DELETE",
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(portalCartApiSlice.util.updateQueryData("getPortalCart", undefined, () => data));
        } catch {}
      },
    }),

    clearPortalCart: builder.mutation({
      query: () => ({
        url: "/api/portal/v1/cart/clear/",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            portalCartApiSlice.util.updateQueryData("getPortalCart", undefined, draft => {
              if (!draft) return;
              draft.items = [];
              draft.subtotal = 0;
              draft.tax_total = 0;
              draft.total = 0;
            }),
          );
        } catch {}
      },
    }),

    submitCheckout: builder.mutation({
      query: body => ({
        url: "/api/portal/v1/checkout/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PortalCart"],
    }),

    getPortalAddresses: builder.query({
      query: () => ({
        url: "/api/portal/v1/addresses/",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetPortalCartQuery,
  useAddPortalCartItemMutation,
  useUpdatePortalCartItemMutation,
  useRemovePortalCartItemMutation,
  useClearPortalCartMutation,
  useSubmitCheckoutMutation,
  useGetPortalAddressesQuery,
} = portalCartApiSlice;
